import firebase from 'firebase';
import { getProcedure } from './procedures';
import { DEFAULT_LANGUAGE } from './constants';


export function getUserProgress(exams) {
    let userProgress = 0
    let total = exams.length
    if (total === 0) return 0

    exams.forEach((exam, index) => {
        userProgress += exam.userHasPassed ? 1 : 0
    })

    return (parseFloat(userProgress * 100) / parseFloat(total)).toFixed(2)
}

export function getDiplomadoVideoData(diplomadoId, currentUserId, lang = DEFAULT_LANGUAGE) {
    return new Promise(async (resolve, reject) => {
        let diplomadoVideos = await firebase.firestore().collection('diplomados').doc(diplomadoId).collection('videos').orderBy('index', 'asc').get().catch(error => { reject(error) })

        let videos = []
        for (const videoDoc of diplomadoVideos.docs) {
            const videoData = videoDoc.data();
            if (videoData.procedureId) {
                const procedure = await getProcedure(videoData.procedureId, lang);
                if (procedure) {
                    videos.push({ 
                        id: videoDoc.id, 
                        ...videoData, 
                        ...procedure, 
                        userHasCompleted: videoData.completed.includes(currentUserId), 
                        active: !!videoData.active 
                    });
                }
            } else {
                videos.push({ 
                    id: videoDoc.id, 
                    ...videoData, 
                    userHasCompleted: videoData.completed.includes(currentUserId), 
                    active: !!videoData.active 
                });
            }
        }
        resolve(videos)
    })
}

export function setDiplomadoVideoCompleted(diplomadoId, currentUserId, videoId) {
    return new Promise(async (resolve, reject) => {
        await firebase.firestore().collection("diplomados").doc(diplomadoId).collection("videos").doc(videoId).update({
            completed: firebase.firestore.FieldValue.arrayUnion(currentUserId)
        }).catch(error => reject(error))

        resolve(true)
    })
}

export function getDiplomado(diplomadoId) {
    return new Promise(async (resolve, reject) => {
        let diplomado = await firebase.firestore().collection('diplomados').doc(diplomadoId).get().catch(error => reject(error))
        resolve({ id: diplomado.id, ...diplomado.data() })
    })
}